module.exports = __webpack_public_path__ + "static/media/grados_pregrado.6a809523.png";